import React, { FC } from 'react';
import styled from 'styled-components';

interface Props {
	children: string;
}

const Container = styled.h2`
	color: ${({ theme }) => theme.colors.text5};
	font-size: 26px;
	font-weight: 700;
	letter-spacing: 0.305px;
	line-height: 32px;
	text-align: center;
`;

export const Title: FC<Props> = props => {
	const { children } = props;
	return <Container>{children}</Container>;
};
